import angular from "angular";
import * as _ from "lodash";
import * as jsonLogic from "json-logic-js";

class EcvDatePicker {
    isOpen: boolean;
    formObj: any;
    formValue: number;
    objAttr;
    fldMdl;
    fldInd;
    minSubFld;
    maxSubFld;

    init(): void {
        this.isOpen = false;
        if(this.formObj.depMinDate){
            this.minSubFld = _.replace(this.formObj.depMinDate.sfield, '${_index_}', this.fldInd);
        }
        if(this.formObj.depMaxDate){
            this.maxSubFld = _.replace(this.formObj.depMaxDate.sfield, '${_index_}', this.fldInd);
        }
       
    }
    getMin = () => {
        if(this.formObj.depMinDate) {            
            let min = _.get(this.fldMdl, this.minSubFld);
            if(!!this.formObj.depMinDate.condition && !!min) {
                min = jsonLogic.apply(this.formObj.depMinDate.condition, {"result": min});
            }
            return min;
        } else
            return this.formObj.minDate;
    }

    getMax = () => {
        if(this.formObj.depMaxDate) {
            let max = _.get(this.fldMdl, this.maxSubFld);
            if(!!this.formObj.depMaxDate.condition && !!max) {
                max = jsonLogic.apply(this.formObj.depMaxDate.condition, {"result": max});
            }
            return max;
        } else
            return this.formObj.maxDate;
    }

    openDatePicker(): void {
        this.isOpen = true;
    }
    isThisDisabled = () => {
        return !!this.objAttr.disabled;
    }
}

function ecvdatepicker(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/schemaFormUtility/components/addons/directives/datePicker/ecvdatepicker.directive.html',
        replace: true,
        controller: EcvDatePicker,
        controllerAs: 'dtpVm',
        scope: true,
        bindToController: {
            'formObj': '=?formObj',
            'formValue': '=?formValue',
            'fldInd': '@?',
            'fldMdl': '=?'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: EcvDatePicker): void => {
            controller.objAttr = attributes;
            controller.init();
        }
    }
}

angular.module('eCareVault.common.schemaForm').directive('ecvdatepicker', ecvdatepicker);
